import api from './api';

const auditoriaService = {
  listar: async (filtros = {}) => {
    const { data } = await api.get('/auditoria', { params: filtros });
    return data.data;
  },
};

export default auditoriaService;